export default __webpack_public_path__ + "static/ProximaNova-Light-367531d5c657281665cd0d8f31ae4b79.otf";